import styled from 'styled-components';

export const WrapperPreguntaEncuestaRadioButton = styled.div``;

export default WrapperPreguntaEncuestaRadioButton;
